import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	"data-testid": "circle",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("rect", {
		className: "outsideCircle",
		x: 1,
		y: 1,
		width: 38,
		height: 38,
		rx: 19,
		stroke: "#ffffff1a",
		strokeWidth: 2
	})]
});
const ForwardRef = forwardRef(SvgCircle);
export { ForwardRef as ReactComponent };
